import React from 'react';
import { List } from 'immutable';
import { useDispatch } from 'react-redux';
import {
  Container,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';
import { trackEvent } from '../../../actions/UI';

import { WysiwygField } from '../../../components';


import './style.scss';

const ParagraphUSPs = ({ entity }) => {
  const dispatch = useDispatch();

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const body = entity.getIn(['field_body', 0, 'processed'], '');
  const usps = entity.getIn(['field_usp'], List());
  const linkHref = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], '');
  const isBecomeMemberCTA = linkHref ? linkHref.includes('-lid') : false;
  const onCtaClick = () => {
    if (isBecomeMemberCTA) {
      dispatch(trackEvent('Lid', 'Klik op "word lid" knop', 'Word lid', null));
    }
  };

  return (
    <Container className="ParagraphUSPs">
      <h2 className="ParagraphUSPs__title">{title}</h2>
      <div className="ParagraphUSPs__desktop__flex">
        <div className="ParagraphUSPs__intro">
          <WysiwygField
            property="schema:text"
            className="ParagraphUSPs__body"
            html={body}
          />
          {linkHref && linkTitle && (
            <Button onClick={onCtaClick} className="ParagraphUSPs__button" href={linkHref}>{linkTitle}</Button>
          )}
        </div>
        <div className="ParagraphUSPs__usps">
          <ul>
            {usps.map((item) => {
              return <li className="ParagraphUSPs__usps__usp" key={item.get('value')}>{item.get('value')}</li>;
            })}
          </ul>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphUSPs;
